/** @format */
//@ts-ignore
import { JDTouchable, JDImage, JDText, JDModal, JDDevice, JDJumping, JDNativeSystem } from '@jdreact/jdreact-core-lib';

import Images from '../../images';

const PropTypes = require('prop-types');

const React = require('react');
const { View, Platform, StyleSheet, StatusBar, Modal } = require('react-native');

// const assets = require('../../assets');
const assets = {} as any;

const DEFAULT_MORE_NAV_CONFIG = [
  {
    icon: assets.webview_nav_message,
    text: '消息',
    handler: () => {
      JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","des":"myMessageBox"}');
    },
  },
  {
    icon: assets.webview_nav_home,
    text: '首页',
    handler: JDJumping.jumpToAppHome,
  },
  {
    icon: assets.webview_nav_search,
    text: '搜索',
    handler: () => {
      JDJumping.jumpToOpenapp('openApp.jdMobile://virtual?params={"category":"jump","des":"search","keyword":"****"}');
    },
  },
  {
    icon: assets.webview_nav_cart,
    text: '购物车',
    handler: () => {
      JDJumping.jumpToOpenapp(
        'openApp.jdMobile://virtual?params={"category":"jump","des":"cartB","skuId":"0","skuNum":"0"}'
      );
    },
  },
];

const noop = () => {};

class NavMoreButton extends React.Component {
  static propTypes = {
    moreNavList: PropTypes.array,
    onMoreNavClick: PropTypes.func,
    onMoreNavItemClick: PropTypes.func,
  };

  static defaultProps = {
    moreNavList: DEFAULT_MORE_NAV_CONFIG,
  };

  state = {
    visible: false,
  };

  render() {
    return (
      <View style={{ marginRight: JDDevice.getRpx(30), height: 44, justifyContent: 'center' }}>
        <JDTouchable onPress={this.onShow} style={styles.navigationBtn}>
          {/* <JDImage source={Images.common.more} style={styles.navigationIcon} /> */}
        </JDTouchable>
        <JDModal onRequestClose={noop} transparent={true} visible={this.state.visible}>
          <JDTouchable style={styles.overlay} onPress={this.onHide} />
          <View style={styles.wrapper}>
            <View style={styles.arrowWrapper}>
              {/* <JDImage source={Images.common.toastArrow} style={styles.arrow} /> */}
            </View>
            <View style={styles.moreNavList}>
              {(this.props.moreNavList || []).map((item: any, index: number) => (
                <JDTouchable
                  onPress={this.onNavClick.bind(this, item.handler, index)}
                  contentContainerStyle={[styles.navItem, index === 0 && { borderTopWidth: 0 }]}
                  key={`item-${index}`}
                >
                  {/* <JDImage source={item.icon} style={styles.navIcon} /> */}
                  <JDText style={styles.navText}>{item.text}</JDText>
                </JDTouchable>
              ))}
            </View>
          </View>
        </JDModal>
      </View>
    );
  }
  onNavClick = (handler: Function, index: number) => {
    let result = false;
    if (typeof this.props.onMoreNavItemClick === 'function') {
      result = this.props.onMoreNavItemClick(index);
    }
    if (result) {
      return;
    }
    this.onHide();
    if (typeof handler === 'function') {
      handler();
    }
  };

  onShow = () => {
    typeof this.props.onMoreNavClick === 'function' && this.props.onMoreNavClick();
    this.setState({
      visible: true,
    });
  };

  onHide = () => {
    this.setState({
      visible: false,
    });
  };
}

const NAVIGATION_BAR_HEIGHT = 44;
const styles = StyleSheet.create({
  navigationIcon: {
    width: JDDevice.getRpx(40),
    height: JDDevice.getRpx(40),
    resizeMode: 'cover',
  },
  overlay: {
    flex: 1,
    // backgroundColor: '#F00',
  },
  wrapper: {
    position: 'absolute',
    ...Platform.select({
      ios: {
        top:
          NAVIGATION_BAR_HEIGHT -
          JDDevice.getRpx(16) +
          JDNativeSystem.statusBarHeight +
          (JDNativeSystem.isIPhoneX ? 8 : 0),
      },
      android: {
        top: NAVIGATION_BAR_HEIGHT - JDDevice.getRpx(16) + StatusBar.currentHeight,
      },
    }),
    right: JDDevice.getRpx(20),
  },
  arrowWrapper: {
    alignItems: 'flex-end',
    paddingRight: JDDevice.getRpx(12),
  },
  arrow: {
    width: JDDevice.getRpx(35),
    height: JDDevice.getRpx(16),
    resizeMode: 'contain',
  },
  moreNavList: {
    backgroundColor: '#232326',
    opacity: 0.9,
    borderRadius: JDDevice.getDpx(6),
    paddingLeft: JDDevice.getRpx(20),
    paddingRight: JDDevice.getRpx(20),
    width: JDDevice.getRpx(280),
  },
  navItem: {
    borderTopColor: '#606062',
    borderTopWidth: JDDevice.getDpx(1),
    flexDirection: 'row',
    height: JDDevice.getRpx(88),
    alignItems: 'center',
    paddingLeft: JDDevice.getRpx(20),
  },
  navIcon: {
    width: JDDevice.getRpx(40),
    height: JDDevice.getRpx(40),
    resizeMode: 'cover',
  },
  navText: {
    color: '#F3F5F9',
    fontSize: JDDevice.getRpx(30),
    marginLeft: JDDevice.getRpx(30),
  },
});

module.exports = NavMoreButton;
